import { CommonPriceElement } from 'common/components/entities/price-element'
import {
  PiceElementPopupType,
  PricePlanPeriodType,
} from 'common/components/entities/price-element/price-element-interface'
import { PriceElementInterface } from 'common/types/entities/price-element-interface'
import { showPopup } from 'publisher/actionsManagement'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { typedPageSelectors, usePage } from 'publisher/store'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useRemoveUnavailablePopups } from 'src/publisher/hooks/use-remove-unavailable-popups'
import { usePricePlans } from './hooks/usePricePlans'
import { PriceElementSkeleton } from './price-element-skeleton'

interface PriceElementProps {
  entity: PriceElementInterface
}

const PriceElement = ({ entity }: PriceElementProps) => {
  const [isClient, setIsClient] = useState(false)
  const locale = usePage(typedPageSelectors.getLocale)
  const { pricePlans, isFetching } = usePricePlans({ locale })
  const dispatch = useDispatch()
  const { t } = useTranslation()

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are correct
  const handleOpenPopup = useCallback(
    (btnId: number = 4, period: PricePlanPeriodType) => {
      let popupIdType: null | PiceElementPopupType = null

      if (period === 'annually') {
        switch (btnId) {
          case 0:
            popupIdType = 'popupIdFirstPlan'
            break
          case 1:
            popupIdType = 'popupIdSecondPlanAnnual'
            break
          case 2:
            popupIdType = 'popupIdThirdPlanAnnual'
            break
          case 3:
            popupIdType = 'popupIdFourthPlanAnnual'
            break
        }
      } else {
        switch (btnId) {
          case 0:
            popupIdType = 'popupIdFirstPlan'
            break
          case 1:
            popupIdType = 'popupIdSecondPlan'
            break
          case 2:
            popupIdType = 'popupIdThirdPlan'
            break
          case 3:
            popupIdType = 'popupIdFourthPlan'
            break
        }
      }

      if (popupIdType) {
        dispatch(showPopup(entity[popupIdType]))
      }
    },
    [
      dispatch,
      entity.popupIdFirstPlan,
      entity.popupIdSecondPlan,
      entity.popupIdThirdPlan,
      entity.popupIdFourthPlan,
      entity.popupIdSecondPlanAnnual,
      entity.popupIdThirdPlanAnnual,
      entity.popupIdFourthPlanAnnual,
    ],
  )

  useEffect(() => {
    setIsClient(true)
  }, [])

  useRemoveUnavailablePopups({
    keys: [
      'popupIdFirstPlan',
      'popupIdSecondPlan',
      'popupIdThirdPlan',
      'popupIdFourthPlan',
      'popupIdSecondPlanAnnual',
      'popupIdThirdPlanAnnual',
      'popupIdFourthPlanAnnual',
    ],
    entity,
    removeType: 'setToNull',
  })

  return (
    <StyleWrapper
      margin={entity.margin}
      appearance={entity.appearance}
      mobileMargin={entity.mobileMargin}
    >
      {isClient ? (
        <CommonPriceElement
          locale={locale}
          pricePlans={pricePlans}
          openPopup={handleOpenPopup}
          t={t}
          isLoading={isFetching}
        />
      ) : (
        <PriceElementSkeleton locale={locale} t={t} />
      )}
    </StyleWrapper>
  )
}

export default PriceElement
